import React from "react";
import { Route, Routes } from "react-router-dom";
import ValueChainDashboard from "../Pages/ValueChain/Dashoboard/ValueChainDashboard";
import UpStream from "../Pages/ValueChain/ValueChainPatners/UpStream/UpStream";
import DownStream from "../Pages/ValueChain/ValueChainPatners/DownStream/DownStream";
import SentRequest from "../Pages/ValueChain/ValueChainRequest/Sent";
import ReceivedRequest from "../Pages/ValueChain/ValueChainRequest/Received";
import NotFound from "../Pages/404/NotFound";
import CommonValuechain from "../Pages/ValueChain/ValueChainRequest/CommonValuechain";
import { elements } from "chart.js";

export const ValueChainRoutes = [
  { path: "/value-chain/dashboard", element: <ValueChainDashboard /> },
  { path: "/value-chain-partner/upstream", element: <UpStream /> },
  { path: "/value-chain-partner/downstream", element: <DownStream /> },
  {
    path: "/value-chain-request",
    element: <CommonValuechain />,
  },
  {path:"*",element:<NotFound />}
];
